import { gql } from '@apollo/client';
const ENDPOINT = {
    GET_ADDRESSLIST: gql`
        query getAddress($eirCode: String!) {
            addressList(eirCode: $eirCode) {
                addresses {
                    addressLine1
                    addressLine2
                    addressLine3
                    town
                    county
                    eircode
                    code
                }
            }
        }
    `,
    GET_OTP: gql`
        query getOTP($msisdn: String!) {
            OTP(msisdn: $msisdn) {
                otpUuid
            }
        }
    `,
    REQUEST_EMAIL_RECOVERY: gql`
        query requestEmailRecovery($msisdn: String!) {
            requestEmailRecovery(msisdn: $msisdn) {
                otpUuid
            }
        }
    `,
    VALIDATE_OTP_EMAIL_RECOVERY: gql`
        mutation validateOTPForEmailRecovery($otpUuid: String!, $otpCode: String!) {
            validateOTPForEmailRecovery(otpUuid: $otpUuid, otpCode: $otpCode) {
                email
                verified
            }
        }
    `,
    VALIDATE_OTP: gql`
        mutation validateOTP($otpUuid: String!, $otp: String!) {
            validateOTP(otpUuid: $otpUuid, otp: $otp)
        }
    `,
    VALIDATE_LOGIN: gql`
        query validateLogin($username: String!, $password: String!) {
            login(username: $username, password: $password) {
                access_token
                expires_in
                refresh_expires_in
                refresh_token
            }
        }
    `,
    EXTEND_SESSION: gql`
        query refreshToken($refresh_token: String!) {
            refreshToken(refresh_token: $refresh_token) {
                access_token
                expires_in
                refresh_expires_in
                refresh_token
            }
        }
    `,
    SERVICE_ID: gql`
        query getMyServices($accountId: Int!) {
            getMyServices(accountId: $accountId) {
                name
                id
                status
                domain
                subscriptionId
                msisdn
                phoneNumber
                pstnUan
                simCardType
                esimStatus
            }
        }
    `,
    GET_USERINFO: gql`
        query getUserInfo {
            getUserInfo {
                sub
                email_verified
                name
                preferred_username
                given_name
                family_name
                email
            }
        }
    `,
    GET_PREPAY_BALANCE: gql`
        query getMyPrepayBalance($serviceId: String!) {
            getMyPrepayBalance(serviceId: $serviceId) {
                balance
            }
        }
    `,
    GET_MY_DETAILS: gql`
        query getMyDetails($serviceId: String!) {
            getMyDetails(serviceId: $serviceId) {
                customerOfferDTO {
                    offerName
                    offerStatus
                    activationDate
                    msisdn
                }
                pin
                puk
            }
        }
    `,
    GET_MY_CONTACT_INFO: gql`
        query getMyContactInfo {
            getMyContactDetails {
                firstName
                phoneNumbers {
                    phoneNumber
                }
            }
        }
    `,
    GET_MY_ADDON: gql`
        query getMyAddons($serviceId: String!) {
            getMyAddons(serviceId: $serviceId) {
                description
            }
        }
    `,
    CONTACT_DETAILS: gql`
        query getContactDetails {
            getMyContactDetails {
                uuid
                phoneNumbers {
                    phoneNumber
                }
                emails {
                    email
                    type
                    validated
                }
                addresses {
                    addressLine1
                    addressLine2
                    addressLine3
                    town
                    county
                    eircode
                    code
                }
                birthDate
                firstName
                lastName
            }
        }
    `,
    GET_PERMISSION: gql`
        query permission {
            getMyPermissionDetails {
                permissionGroupResponse {
                    name
                    permissions {
                        name
                        enabled
                        permission
                    }
                }
                allowThirdParty
            }
        }
    `,
    GET_NDDPREFERENCE: gql`
        query getNDDPreference($serviceId: Int!) {
            getMyNDDPreference(serviceId: $serviceId) {
                nddPreference
            }
        }
    `,
    UPDATE_NDDPREFERENCE: gql`
        mutation nddPreference($serviceId: Int!, $nddPreference: String!) {
            updateMyNDD(serviceId: $serviceId, nddPreference: $nddPreference)
        }
    `,

    UPDATE_BILLDELIVERYTYPE: gql`
        mutation updateBillDeliveryType($accountId: String!, $invoiceDeliveryMethod: String!) {
            updateBillDeliveryType(
                accountId: $accountId
                invoiceDeliveryMethod: $invoiceDeliveryMethod
            )
        }
    `,
    UPDATE_CONTACT_PERMISSION_GROUP: gql`
        mutation updateMyContactPermission($permissionGroups: [PermissionGroupsResponseInput!]) {
            updateMyContactPermission(permissionGroups: $permissionGroups)
        }
    `,
    GET_VESTA_TOKEN: gql`
        query getVestaToken($msisdn: String!) {
            getVestaToken(msisdn: $msisdn) {
                vestaToken
            }
        }
    `,
    GET_SECURITYQUESTIONS: gql`
        query securityQuestions {
            securityQuestions {
                code
                question
            }
        }
    `,
    NUMBER_VALIDATION: gql`
        mutation validateUser(
            $registerWith: String!
            $registerValue: String!
            $recaptcha: String!
        ) {
            validateUser(
                registerWith: $registerWith
                registerValue: $registerValue
                recaptcha: $recaptcha
            ) {
                otpUuid
                statusCode
                mobileNumber
                contactFound
            }
        }
    `,
    RESET_PASSWORD: gql`
        mutation resetPassword($emailAddress: String!, $brand: BillingSystem) {
            resetPassword(emailAddress: $emailAddress, brand: $brand) {
                message
            }
        }
    `,
    SET_PASSWORD: gql`
        mutation setpassword($username: String!, $password: String!, $token: String!) {
            setPassword(username: $username, password: $password, token: $token) {
                message
            }
        }
    `,
    GET_SUBSCRIPTION_ID_AND_CONTACT: gql`
        query getMySubscriptionsAndContactDetails {
            getMySubscriptions {
                content {
                    id
                    accountId
                    catalogOfferId
                    serviceGroup
                    type
                    dependsOn
                    terminatedAt
                    orderReference
                }
            }
            getMyContactDetails {
                firstName
                phoneNumbers {
                    phoneNumber
                }
            }
        }
    `,

    GET_BALANCE_DETAILS_ADDONS: gql`
        query getMyPrepayBalanceMyDetailsMyAddons($serviceId: String!) {
            getMyPrepayBalance(serviceId: $serviceId) {
                balance
            }
            getMyDetails(serviceId: $serviceId) {
                customerOfferDTO {
                    offerName
                    offerStatus
                    activationDate
                    msisdn
                    name
                    status
                }
                pin
                puk
            }
            getSimCardDetails(serviceId: $serviceId) {
                imsiNumber
                pin1Code
                puk1Code
                serviceId
            }
            getMyAddons(serviceId: $serviceId) {
                description
                status
            }
        }
    `,
    GET_PROFILE_DETAILS: gql`
        query getProfileDetails($serviceId: Int!) {
            getMyContactDetails {
                uuid
                phoneNumbers {
                    phoneNumber
                }
                emails {
                    email
                    type
                    validated
                }
                addresses {
                    addressLine1
                    addressLine2
                    addressLine3
                    town
                    county
                    eircode
                    code
                }
                birthDate
                firstName
                lastName
            }
            getMyNDDPreference(serviceId: $serviceId) {
                nddPreference
            }
            getMyPermissionDetails {
                permissionGroupResponse {
                    name
                    permissions {
                        name
                        enabled
                        permission
                    }
                }
                allowThirdParty
            }
        }
    `,
    GET_USAGE_TYPES: gql`
        query getMyUsageTypes {
            getMyUsageTypes {
                ratingSubtotalTypes {
                    ratingSubtotalLevel
                    ratingSubtotalDisplayName
                    key
                }
            }
        }
    `,
    GET_USAGE_SUMMARY: gql`
        query getMyUsageSummary(
            $billingPeriod: String!
            $subscriptionType: String!
            $serviceId: Int!
        ) {
            getMyUsageSummary(
                billingPeriod: $billingPeriod
                subscriptionType: $subscriptionType
                serviceId: $serviceId
            ) {
                accountServiceId
                billPeriodEndDate
                billPeriodStartDate
                usageSummary {
                    amount
                    billable
                    eventCount
                    measuringUnit
                    quantity
                    roundedQuantity
                    usageCategory
                    usageType
                    usageTypeName
                }
            }
        }
    `,
    GET_USAGE_DETAILS: gql`
        query getMyUsageDetails($usageDetailsInput: UsageDetailsInput!) {
            getMyUsageDetails(usageDetailsInput: $usageDetailsInput) {
                usage {
                    first
                    last
                    number
                    numberOfElements
                    size
                    totalElements
                    totalPages
                    content {
                        amount
                        chargedNumber
                        chargeStartDateTime
                        destinationCarrierCode
                        destinationCountryCode
                        destinationNumber
                        general1
                        general2
                        general3
                        general4
                        general5
                        measuringUnit
                        originCountryCode
                        originNumber
                        quantity
                        roaming
                        roamingCarrierCode
                        roundedQuantity
                        terminating
                        trafficCategorization
                        usageCategory
                        usageId
                        usageType
                        usageTypeName
                    }
                }
            }
        }
    `,
    UPDATE_REGISTER_DETAILS: gql`
        mutation registration(
            $msisdn: String!
            $customerDetailForRegistrationInput: CustomerDetailForRegistrationInput!
        ) {
            registration(
                msisdn: $msisdn
                customerDetailForRegistrationInput: $customerDetailForRegistrationInput
            )
        }
    `,
    SEND_VERIFICATION_EMAIL: gql`
        mutation sendVerificationEmail($email: String!) {
            sendVerificationEmail(email: $email)
        }
    `,
    AREA_CODES: gql`
        query areacode {
            areaCodes {
                AREA_CODE
            }
        }
    `,
    GET_OPERATOR: gql`
        query getOperator($msisdn: String!) {
            operator(msisdn: $msisdn) {
                brand
                network {
                    id
                    networkName
                }
            }
        }
    `,
};

export default ENDPOINT;
